import { render, staticRenderFns } from "./QuestionsForm.vue?vue&type=template&id=14788157&"
import script from "./QuestionsForm.vue?vue&type=script&lang=ts&"
export * from "./QuestionsForm.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
